export default build.IS_HEADLESS
